// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#flexslider-18 img {
    margin-top: unset !important;
}

.contact-social-media img {
    margin-top: 0;
    position: absolute;
}
`, "",{"version":3,"sources":["webpack://./public/frontend/src/pages/home.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":["#flexslider-18 img {\n    margin-top: unset !important;\n}\n\n.contact-social-media img {\n    margin-top: 0;\n    position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
